import { useEffect } from 'react'
import '../assets/styles/ItemCard.css'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default function ItemCard(props) {

    const showCanva = () => {
        props.setItemInfoModalVisible(true)
        props.setItemInfoModalData(props.itemData)
    }

    const renderTooltip = (gemData) => (
        <Tooltip id="item-tooltip">
            <div className="d-flex flex-column">
                <span className='fs-4 fw-bold'>
                    {gemData.name}
                </span>
                <span className='fs-5 text-warning fw-bold'>
                    {gemData.type}
                </span>
            </div>
        </Tooltip>
    );

    const hexToRgba = (hex, alpha) => {
        hex = hex.replace(/^#/, '');

        if (hex.length === 3) {
            hex = hex.split('').map(x => x + x).join('');
        }

        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    const extractGems = (descriptions) => {
        if (!descriptions) return [];

        return descriptions
            .filter(desc => desc.value.includes("Gem"))
            .flatMap(desc => {
                const matches = [...desc.value.matchAll(/background-image: url\(([^)]+)\).*?>([^<]+)<\/span><br><span[^>]+>([^<]+)<\/span>/gs)];
                return matches.map(match => ({ image: match[1], name: match[2], type: match[3] }));
            });
    };

    return (
        <div className='item-card-wrap border border-3 rounded'>
            <div className="item-card h-100 w-100" tabIndex={-1}>
                <img onClick={props.onClick} alt="" src={props.itemData.image}></img>
                <div className="d-flex align-items-center justify-content-center rounded text-light price-tag" style={{ backgroundColor: `${hexToRgba(props.itemData.rarityColor, 0.8)}` }}>
                    {props.itemData.priceSafe} $
                </div>
                <div onClick={showCanva} className='item-info text-light'>
                    <i className="bi bi-info-square-fill"></i>
                </div>
                {props.itemData.descriptions !== null ?
                    <div className='item-gems'>
                        {extractGems(props.itemData.descriptions).map((gem, i) => (
                            <OverlayTrigger
                                trigger={['hover','focus']}
                                placement="bottom"
                                delay={{ show: 0, hide: 0 }}
                                overlay={renderTooltip(
                                    {
                                        name: gem.name,
                                        type: gem.type
                                    }
                                )}
                            >
                                <div className='gem-image border border-warning rounded'
                                    key={i}
                                    style={{
                                        backgroundImage: `url(${gem.image})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center"
                                    }}
                                >
                                    {/* Add any content inside if needed */}
                                </div>
                            </OverlayTrigger>
                        ))}
                    </div>
                    :
                    ""
                }
            </div>
        </div>
    )
}